import React from 'react';
import { BRAND, HERO, COLORS } from '../../data/siteData';

// Hero background image provided by user
const HERO_BG_IMAGE = "https://customer-assets.emergentagent.com/job_knygomatai-clone/artifacts/x40pi54o_image.png";

const HeroSection = ({ onDemoClick, onInstallationsClick }) => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: `url(${HERO_BG_IMAGE})`,
        }}
      />
      
      {/* Yellow Overlay Filter */}
      <div 
        className="absolute inset-0"
        style={{ 
          backgroundColor: COLORS.yellow,
          opacity: 0.35,
          mixBlendMode: 'multiply'
        }}
      />
      
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-black/30" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 lg:py-40">
        <div className="max-w-3xl">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-white">
            <span style={{ color: COLORS.yellow }}>{BRAND.name}</span>
            <span style={{ color: COLORS.yellow }}>®</span>
            <br />
            <span className="text-3xl sm:text-4xl lg:text-5xl font-normal text-white">
              {HERO.title}
            </span>
          </h1>
          <p className="mt-6 text-lg text-white/90">
            {HERO.subtitle}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <button
              onClick={onDemoClick}
              className="px-8 py-3 text-base font-medium text-white rounded-lg transition-all hover:opacity-90 shadow-lg"
              style={{ backgroundColor: COLORS.green }}
              data-testid="hero-demo-btn"
            >
              {HERO.cta1}
            </button>
            <button
              onClick={onInstallationsClick}
              className="px-8 py-3 text-base font-medium rounded-lg transition-all hover:bg-white/20 border-2 border-white text-white"
              data-testid="hero-installations-btn"
            >
              {HERO.cta2}
            </button>
          </div>
          
          {/* 24/7 Badge */}
          <div 
            className="mt-12 inline-flex items-center space-x-3 bg-white/95 rounded-xl shadow-lg p-4"
            style={{ borderLeft: `4px solid ${COLORS.yellow}` }}
          >
            <span className="text-3xl font-bold" style={{ color: COLORS.yellow }}>24/7</span>
            <span className="text-sm" style={{ color: COLORS.gray }}>Pasiekiamas visuomet</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
